export default "<div class=\"spinner-ball-styles\" [ngClass]=\"spinnerStyles\">\n  <div></div>\n  <div></div>\n  <div></div>\n  <div></div>\n</div>\n";